import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Typography, TextField, Button, Checkbox, FormControlLabel, Box, Autocomplete, Radio, RadioGroup, FormControl, FormLabel } from '@mui/material';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useNavigate } from 'react-router-dom';

const AddMatch = () => {
  const navigate = useNavigate();
  const [homeTeam, setHomeTeam] = useState(null);
  const [awayTeam, setAwayTeam] = useState(null);
  const [matchDate, setMatchDate] = useState(new Date());
  const [homeGoals, setHomeGoals] = useState('');
  const [awayGoals, setAwayGoals] = useState('');
  const [neutralVenue, setNeutralVenue] = useState(false);
  const [teamOptions, setTeamOptions] = useState([]);
  const [searchTermHome, setSearchTermHome] = useState('');
  const [searchTermAway, setSearchTermAway] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [kValue, setKValue] = useState('10'); // Domyślna wartość K

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/teams`);
        const data = response.data;
        const teams = data.map(team => ({
          id: team.teamId,
          name: team.teamName,
          elo: team.eloRanking, // Dodanie rankingu ELO do obiektu drużyny
        }));
        setTeamOptions(teams);
        setLoading(false);
      } catch (err) {
        setError('Błąd podczas pobierania drużyn z API.');
        console.error('Błąd API:', err);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const filteredTeamsHome = teamOptions.filter(team =>
    !homeTeam || team.id !== homeTeam.id
  ).filter(team =>
    team.name.toLowerCase().includes(searchTermHome.toLowerCase())
  );

  const filteredTeamsAway = teamOptions.filter(team =>
    !awayTeam || team.id !== awayTeam.id
  ).filter(team =>
    team.name.toLowerCase().includes(searchTermAway.toLowerCase())
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const homeElo = homeTeam ? homeTeam.elo : null; // Pobranie rankingu ELO dla gospodarzy
      const awayElo = awayTeam ? awayTeam.elo : null; // Pobranie rankingu ELO dla gości
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/matches`, {
        homeTeamId: homeTeam.id,
        awayTeamId: awayTeam.id,
        homeTeamName: homeTeam.name,
        awayTeamName: awayTeam.name,
        matchDate: matchDate.getTime(),
        homeGoals: homeGoals ? parseInt(homeGoals) : null,
        awayGoals: awayGoals ? parseInt(awayGoals) : null,
        neutralVenue,
        homeElo, // Dodanie rankingu ELO gospodarzy
        awayElo, // Dodanie rankingu ELO gości
        kValue: parseInt(kValue), // Dodanie wartości K
      });
      console.log('Odpowiedź z serwera:', response.data);
      alert('Mecz dodany! Przeliczenie Elo w toku...');
      navigate('/janekjot');
    } catch (error) {
      console.error('Błąd podczas wysyłania meczu:', error);
      alert('Błąd podczas dodawania meczu.');
    }
  };

  if (loading) {
    return (
      <Box sx={{ textAlign: 'center', padding: '20px' }}>
        <Typography variant="h6">Ładowanie...</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ textAlign: 'center', padding: '20px' }}>
        <Typography variant="h6">{error}</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ padding: '20px', maxWidth: '600px', margin: '0 auto', position: 'relative' }}>
      <Typography variant="h4" gutterBottom>
        Dodaj Mecz Sparingowy
      </Typography>
      <form onSubmit={handleSubmit}>
        <DatePicker
          selected={matchDate}
          onChange={(date) => setMatchDate(date)}
          customInput={<TextField label="Data i godzina meczu" fullWidth margin="normal" />}
          dateFormat="dd/MM/yyyy HH:mm"
          showTimeSelect
          timeFormat="HH:mm"
          timeIntervals={15}
          popperClassName="date-picker-popper" // Dodanie klasy dla dostosowania z-index
          portalId="date-picker-portal" // Opcjonalne użycie portalu dla lepszego nakładania
        />

        <Autocomplete
          options={filteredTeamsHome}
          getOptionLabel={(option) => option.name}
          value={homeTeam}
          onChange={(event, newValue) => setHomeTeam(newValue)}
          inputValue={searchTermHome}
          onInputChange={(event, newInputValue) => setSearchTermHome(newInputValue || '')}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Gospodarze"
              margin="normal"
              fullWidth
            />
          )}
        />

        <Autocomplete
          options={filteredTeamsAway}
          getOptionLabel={(option) => option.name}
          value={awayTeam}
          onChange={(event, newValue) => setAwayTeam(newValue)}
          inputValue={searchTermAway}
          onInputChange={(event, newInputValue) => setSearchTermAway(newInputValue || '')}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Goście"
              margin="normal"
              fullWidth
            />
          )}
        />

        <TextField
          label="Gole drużyny gospodarzy"
          type="number"
          value={homeGoals}
          onChange={(e) => setHomeGoals(e.target.value)}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Gole drużyny gości"
          type="number"
          value={awayGoals}
          onChange={(e) => setAwayGoals(e.target.value)}
          fullWidth
          margin="normal"
        />

        <FormControlLabel
          control={<Checkbox checked={neutralVenue} onChange={(e) => setNeutralVenue(e.target.checked)} />}
          label="Neutralne miejsce"
          sx={{ mt: 1 }}
        />

        <FormControl component="fieldset" sx={{ mt: 2 }}>
          <FormLabel component="legend">Wartość K:</FormLabel>
          <RadioGroup
            row
            value={kValue}
            onChange={(e) => setKValue(e.target.value)}
          >
            <FormControlLabel value="10" control={<Radio />} label="K = 10" />
            <FormControlLabel value="20" control={<Radio />} label="K = 20" />
          </RadioGroup>
        </FormControl>

        <Button variant="contained" color="primary" type="submit" sx={{ mt: 2 }}>
          Dodaj mecz i przelicz Elo
        </Button>
      </form>

      {/* Mała czcionka w rogu formatki */}
      <Typography
        variant="caption"
        sx={{
          position: 'absolute',
          bottom: 10,
          right: 10,
          color: 'gray',
          fontSize: '0.6rem',
        }}
      >
      </Typography>
    </Box>
  );
};

export default AddMatch;